import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomFilterModel } from '@bo-client/shared/models/userBackOfficeSettings';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

type FilterForm = FormGroup<{
  name: FormControl<string>;
}>;

@Component({
  selector: 'app-custom-filter-modal',
  templateUrl: './custom-filter-modal.component.html',
  styleUrls: ['./custom-filter-modal.component.scss']
})
export class CustomFilterModalComponent {
  matDialogRef = inject(MatDialogRef<CustomFilterModalComponent, string | null>);
  readonly data: {
    name: CustomFilterModel['name'];
  } = inject(MAT_DIALOG_DATA);

  formGroup: FilterForm = inject(FormBuilder).group({
    name: [this.data.name || '', Validators.required]
  });

  cancel() {
    this.matDialogRef.close(null);
  }

  confirm(formGroup: FilterForm) {
    if (formGroup.invalid) {
      formGroup.markAllAsTouched();
      return;
    }
    this.matDialogRef.close(formGroup.getRawValue().name);
  }
}
